export const EXSBBATCHNUMBER_DELETE_RESET = 'EXSBBATCHNUMBER_DELETE_RESET'
export const EXSBBATCHNUMBER_DELETE_SET_ERROR = 'EXSBBATCHNUMBER_DELETE_SET_ERROR'
export const EXSBBATCHNUMBER_DELETE_SET_DELETED = 'EXSBBATCHNUMBER_DELETE_SET_DELETED'
export const EXSBBATCHNUMBER_DELETE_TOGGLE_LOADING = 'EXSBBATCHNUMBER_DELETE_TOGGLE_LOADING'
